import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import HamburgerMenu from "react-hamburger-menu"
import { useScrollYPosition } from "react-use-scroll-position"

// import material ui
import AppBar from "@material-ui/core/AppBar"

// import app components
import MainMenu from "../menu/MainMenu"
import MobileMenu from "../menu/MobileMenu"

import Edges from "../../components/_layout/edges"

import FraserviewLogo from "../../images/fraserview-logo.svg"

import * as theme from "../../theme"

const Header = props => {
  const { path } = props

  const [menuState, setMenuState] = useState(false)
  const [pinned, setPinned] = useState(false)

  const scrollY = useScrollYPosition()

  useEffect(() => {
    setMenuState(false)
  }, [path])

  useEffect(() => {
    setPinned(!!(scrollY > 50) || menuState)
  }, [scrollY, menuState])

  return (
    <StyledAppBar
      position="fixed"
      pinned={pinned ? 1 : undefined}
      id="fixed-header"
    >
      <Edges size="lg">
        <Nav>
          <Logo to="/">
            <FraserviewLogo />
          </Logo>
          <MenuContainer>
            <MainMenu pinned={pinned} />
          </MenuContainer>
          <MobileBtn onClick={() => setMenuState(!menuState)}>
            <HamburgerMenu
              color={pinned ? theme.color.primary : "white"}
              isOpen={menuState}
              width={18}
              height={15}
              strokeWidth={1}
              menuClicked={() => ""}
            />
          </MobileBtn>
        </Nav>
      </Edges>

      <MobileMenu menuState={menuState} />
    </StyledAppBar>
  )
}

export default Header

const StyledAppBar = styled(AppBar)`
  will-change: color, background;
  && {
    transition: all 0.3s ease-in-out;
    ${({ pinned }) =>
      pinned
        ? css`
            color: ${theme.color.primary};
            background: white !important;
          `
        : css`
            box-shadow: none;
            color: white;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.4) 0%,
              rgba(0, 0, 0, 0) 100%
            ) !important;
          `}
  }
`

const Nav = styled.div`
  display: flex;
  justify-content: space-between;
`

const Logo = styled(Link)`
  svg {
    height: auto;
    width: 238px;
  }
  color: white;
  text-decoration: none;
  padding: 16px 0;
`

const MenuContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  @media (max-width: 908px) {
    display: none;
  }
`
const MobileBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
  cursor: pointer;
  @media screen and (min-width: 909px) {
    display: none;
  }
`
